import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatError(err) {
  const detail = err?.response?.data?.detail ?? err?.detail;
  if (detail == null) return err?.message || "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

const postJson = (path, body) => fetch(`${API}${path}`, {
  method: "POST", credentials: "include",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(body),
});

export async function streamPost(path, body, onEvent) {
  let res = await postJson(path, body);
  if (res.status === 401) {
    await api.post("/auth/refresh");
    res = await postJson(path, body);
  }
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw Object.assign(new Error(formatError({ detail: d.detail })), { status: res.status });
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const line = buf.slice(0, i);
      buf = buf.slice(i + 2);
      if (line.startsWith("data: ")) onEvent(JSON.parse(line.slice(6)));
    }
  }
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" }) : "—";
export const fmtMoney = (amount, currency = "usd") =>
  `${Number(amount) < 0 ? "-" : ""}$${Math.abs(Number(amount || 0)).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency.toUpperCase()}`;

export const EXAMPLES = [
  "Sistema de inventarios", "Punto de venta", "Agenda de citas", "Administración de clientes",
  "Control de gastos", "Sistema de cotizaciones", "Gestión de pedidos", "Plataforma de cursos",
  "Administración de negocios", "Formularios y encuestas",
];

export const WEBSITE_EXAMPLES = [
  "Sitio web para restaurante", "Landing page de producto", "Portafolio profesional", "Sitio para consultorio médico",
  "Catálogo de productos", "Página para evento", "Sitio para despacho de abogados", "Página de academia o escuela",
];

export const PENDING_KEY = "synapsis_pending_prompt";

export async function startProject(prompt, name, type = "app") {
  const { data } = await api.post("/projects", {
    name: (name || prompt).slice(0, 60),
    description: prompt,
    type,
  });
  return data;
}
